export function hexToRgba(hex: string, alpha: number | undefined): string {
  /* for Corin Opacity */
  if (/^#([0-9A-F]{3}){1,2}$/i.test(hex)) {
    let r = 0;
    let g = 0;
    let b = 0;

    if (hex.length === 4) {
      r = parseInt(hex.charAt(1), 16);
      g = parseInt(hex.charAt(2), 16);
      b = parseInt(hex.charAt(3), 16);
    }

    if (hex.length === 7) {
      r = parseInt(hex.slice(1, 3), 16);
      g = parseInt(hex.slice(3, 5), 16);
      b = parseInt(hex.slice(5, 7), 16);
    }
    if (alpha !== undefined && alpha >= 0 && alpha <= 100) {
      alpha = alpha / 100;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    } else {
      return hex;
    }
  }
  return '';
}

/*youtube videos url are checked*/
export const validateVideoUrl = (url: string): string => {
  if (url && url !== '') {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\?v=)([^#?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
      return `https://www.youtube.com/embed/${match[2]}`;
    }
  }
  return url;
};
